var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("vat-listing")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      disabled: _vm.sending,
                      fancy: "",
                      label: _vm.$ct("common.Year"),
                      decimals: 0,
                    },
                    model: {
                      value: _vm.year,
                      callback: function ($$v) {
                        _vm.year = $$v
                      },
                      expression: "year",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "confirm mr",
              attrs: { disabled: _vm.sending, icon: "file-pdf" },
              on: {
                click: function ($event) {
                  return _vm.downloadPdf()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.download-pdf")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              staticClass: "confirm",
              attrs: { disabled: _vm.sending, icon: "download" },
              on: {
                click: function ($event) {
                  return _vm.download()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.download")))]
          ),
        ],
        1
      ),
      _vm.onClientsModalConfirmFunction
        ? _c("app-account-vat-listing-ambigous-clients-modal", {
            attrs: { "on-ready": _vm.onClientsModalConfirmFunction },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }